import { Link } from 'react-router-dom';
import Loading from '../loading';
import { PageContent, StyledBreadcrumb } from './styles';

const Page = ({ loading, breadcrumb = [], children, ...props }) => {
  if (loading) {
    return <Loading padding={64} />;
  }

  const breadcrumbItems = [
    { title: <Link to="/">Home</Link>, key: 'home' },
    ...breadcrumb
      .filter((item) => item)
      .map((item, key) => ({
        title: item.path ? <Link to={item.path}>{item.label}</Link> : item.label || item,
        key,
      })),
  ];

  return (
    <>
      <StyledBreadcrumb items={breadcrumbItems} />
      <PageContent {...props}>{children}</PageContent>
    </>
  );
};

export default Page;
